import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc7e0024"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "loading-overlay"
}
const _hoisted_2 = ["src"]

import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppGettersTypes } from '@/store/modules/app'
import { getLocaleText } from '@/utils/tools'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const loadingLabel = computed(() => {
  return `${getLocaleText('LOADING')}...`
})
const isloading = computed(() => {
  return store.getters[AppGettersTypes.GET_LOADING_STATUS]
})

return (_ctx: any,_cache: any) => {
  return (_unref(isloading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_unref(loadingLabel)) + " ...", 1),
        _createElementVNode("img", {
          style: {"width":"40px","margin-top":"20px"},
          src: require('@/assets/images/loading.svg')
        }, null, 8, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})